import React from "react";
import Header from "./Header";

export interface LayoutProps {
    children: React.ReactNode;
}

const NoweZgloszenieLayaut = ({children}: LayoutProps) => {
    return (
        <div className={'noweZgloszenieMain'}>
            <Header/>
            <div style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '1200px'}}>
                {children}
            </div>
        </div>
    )
}

export default NoweZgloszenieLayaut;
